import React from 'react';
import Rewind from './actions/Rewind';
import Dislike from './actions/Dislike';
import Like from './actions/Like';
import Superlike from './actions/Superlike';

const Actions = ({ person, modifySuperficialChoices }) => (
  <div id="actions">
    {/*<Rewind userId={person.id} />*/}
    <Dislike
      userId={person}
      modifySuperficialChoices={modifySuperficialChoices}
    />
    <Like
      userId={person}
      modifySuperficialChoices={modifySuperficialChoices}
    />
    {/*<Superlike*/}
    {/*  userId={person}*/}
    {/*  modifySuperficialChoices={modifySuperficialChoices}*/}
    {/*/>*/}
  </div>
);

export default Actions;
